module.exports = __webpack_public_path__ + "static/media/userIdPhoto.a347c74f.jpg";